import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Layout from '@oncore/ui/Layout';
import ChromeTopBar from './ChromeTopBar';
import ChromeSideBar from './ChromeSideBar';
import { OncoreFlexLayout } from 'src/components/chrome';
import { getAppStateSelector, getUserSelector } from 'src/store/selectors';
import TwoFactorAuthBanner from 'src/components/banner/TwoFactorAuthBanner';
import { useDisclose } from '@oncore/shared';

const StyledLayout = styled(Layout)`
  height: 100vh;
  width: 100vw;

  &[data-is2fa-banner-visible='true'] {
    .content-container {
      flex-direction: column;
      > div:nth-child(2) {
        flex-grow: 1;
      }
    }
  }
`;

const Chrome = () => {
  const { security } = useSelector(getUserSelector());
  const { isUntitledUI } = useSelector(getAppStateSelector());
  const isTwoFactorAuthEnabled = security.isMultiFactorAuthenticationEnabled;

  const { 
    isOpen, 
    onClose 
  } = useDisclose(true);
  const isTwoFactorAuthBannerVisible = !isTwoFactorAuthEnabled && isOpen;

  const content = isTwoFactorAuthBannerVisible ? (
    <>
      <TwoFactorAuthBanner
        isOpen={isOpen}
        onClose={onClose}
      />
      <Outlet />
    </>
  ) : (
    <Outlet />
  );

  if (isUntitledUI) {
    return (
      <StyledLayout
        product="omp"
        content={content}
        topbar={<ChromeTopBar />}
        sidebar={<ChromeSideBar />}
        data-is2fa-banner-visible={isTwoFactorAuthBannerVisible}
      />
    );
  }

  return <OncoreFlexLayout />;
};

export default Chrome;
